import styled from "styled-components";

const StyledFilterList = styled.div`
  padding: 30px;
  height: 100vh;
  overflow-y: auto;
`;

export default StyledFilterList;
